var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "19", height: "12", viewBox: "0 0 19 12", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2 2.5l7.5 7.41L17 2", stroke: "#E6E7E8", strokeWidth: "2.3", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});